<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Modal } from "bootstrap";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // assets expensis
      currentAssetsExpensis: [],
      paymentTypes: [
        { id: 1, name: "مديونية", name_en: "Pay On Credit" },
        { id: 2, name: "دفع جزئي", name_en: "Parital Pay" },
        { id: 3, name: "دفع كامل", name_en: "Full Pay" },
      ],
      // end asets expensis
      creditMainChartOfAccountsId: 3,
      debitMainChartOfAccountsId: 2,
      donations: [],
      showedEditedDonation: {},
      agent: {},
      editedAgent: {},
      levelOne: [],
      levelTwo: [],
      currentAssets: [],
      currentExpensis: [],
      addAsset: [{}],
      addExpense: [{}],
      addAccounts: [{}],
      seletedPurchase: {},
      seletedEditedPurchase: {},
      addOrEditDonation: { donations: [{}] },
      editPurchase: [
        {
          addAsset: [{}],
          addExpense: [{}],
          purchaseType: "",
        },
      ],
      editAgent: {},
      isOnCredit: true,
      page: 1,
      limit: 20,
      tot_pages: 0,
      branch_id: null,
      searchModel: "",
      reference_no: null,
      add_or_edit_donation_modal: {},
      donators: [],
      company_branches: [],
      branch_sites: [],
      fixed_assets: [],
      isItEdit: false,
      donation_details_modal: {},
    };
  },
  methods: {
    deleteDonation(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("donations", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    // end assets expensis

    showShowDonation(donation) {
      this.showedEditedDonation = donation;
      this.donation_details_modal.show();
    },
    get(page) {
      console.log(page);
      this.http
        .post("donations/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.donations = res.data;
        });
    },
    search(page) {
      if (!this.searchModel.length) return this.cancelSearchMode();
      this.http
        .post("donations/search", {
          limit: this.limit,
          page: page,
          search: this.searchModel,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.donations = res.data;
        });
    },
    cancelSearchMode() {
      this.get(this.page);
    },

    preAddDonation() {
      this.isItEdit = false;
      this.addOrEditDonation = { donations: [{}] };
      this.add_or_edit_donation_modal.show();
    },
    donatorSearch(search) {
      this.http
        .post("donators/search", {
          search,
          page: 1,
          limit: 20,
        })
        .then((res) => {
          if (res.status) {
            this.donators = res.data;
          }
        });
    },
    fixedAssetSearch(search) {
      this.http
        .post("fixed-assets/search", {
          search,
          page: 1,
          limit: 20,
        })
        .then((res) => {
          if (res.status) {
            this.fixed_assets = res.data;
          }
        });
    },

    showDonatorLabel(one) {
      console.log("step 139 :", one);

      return this.$i18n.locale == "en" ? one.name_en : one.name;
    },
    selectDonator(donator) {
      this.addOrEditDonation.donator_id = donator.id;
    },
    getBranches() {
      this.http.get("branches").then((res) => {
        if (res.status) this.company_branches = res.data;
      });
    },
    getBranchSites(branch_id, index) {
      console.log(index);
      return new Promise((resolve) => {
        this.http
          .post("level-one-chart-of-accounts/get-branch-sites", { branch_id })
          .then((resp) => {
            console.log(resp.data);
            resolve(resp.data);
            this.addOrEditDonation.donations[index].branch_sites = resp.data;
          });
      });
      // this.addOrEditDonation.donations[index].branch_site_id = null;
    },
    registerFixedAssetProductDonation() {
      console.log("step 314", this.addOrEditDonation);

      this.http.post("donations", this.addOrEditDonation).then((res) => {
        if (res.status) {
          this.add_or_edit_donation_modal.hide();
          this.get(this.page);
        }
      });
    },
    editFixedAssetProductDonation() {
      console.log("step 314", this.addOrEditDonation);

      this.http
        .put("donations", this.addOrEditDonation.id, this.addOrEditDonation)
        .then((res) => {
          if (res.status) {
            this.add_or_edit_donation_modal.hide();
            this.get(this.page);
          }
        });
    },
    async preEditDonation(record) {
      this.isItEdit = true;
      this.addOrEditDonation = {
        id: record.id,
        reference_no: record.reference_no,
        donator: Object.assign({}, record.donator),
        donations: JSON.parse(JSON.stringify(record.donation_details)),
      };
      for (let index = 0; index < record.donation_details.length; index++) {
        record.donation_details[index].branch_sites = await this.getBranchSites(
          record.donation_details[index].branch_id,
          index
        );
      }
      this.add_or_edit_donation_modal.show();
    },

    completeDonation(record) {
      var data = {
        title: "popups.confirm",
        msg: "donations.confirm",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.post("donations/complete/" + record.id, {}).then((res) => {
            if (res.status) {
              this.get(this.page);
            }
          });
        }
      });
    },
    receiveDonation(record) {
      var data = {
        title: "popups.confirm",
        msg: "donations.receive",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.post("donations/receive/" + record.id, {}).then((res) => {
            if (res.status) {
              this.get(this.page);
            }
          });
        }
      });
    },
  },
  created() {
    this.get(1);
    this.getBranches();
  },
  mounted() {
    this.add_or_edit_donation_modal = new Modal("#addOrEditDonationModal");
    this.donation_details_modal = new Modal("#donationDetailsModal");
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('fixed_assets.donations')"
    />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @input="search(page)"
                    type="search"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="searchModel"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                </div>
              </div>
            </div>
            <div class="col-6">
              <button
                type="button"
                @click="preAddDonation()"
                class="btn btn-light float-end mb-4"
              >
                <span
                  class="bx bxs-plus-circle float-end fa-2x"
                  style="color: #2a3042 !important"
                ></span>
              </button>
            </div>
          </div>

          <table
            class="table table-centered table-nowrap table-striped table-hover align-middle"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <th scope="col">#</th>
                <th scope="col">{{ $t("donations.code") }}</th>
                <th scope="col">{{ $t("donations.reference_no") }}</th>
                <th scope="col">{{ $t("fixed_assets.donator") }}</th>
                <th scope="col">{{ $t("purchases.total") }}</th>
                <th scope="col">{{ $t("purchases.created") }}</th>

                <th scope="col">{{ $t("purchases.operations") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(app, index) in donations" :key="app" class="">
                <td>{{ (page - 1) * limit + index + 1 }}</td>
                <td>{{ "#" + app?.id }}</td>
                <td>{{ app?.reference_no }}</td>

                <td>
                  {{
                    $i18n.locale == "ar"
                      ? app?.donator?.name
                      : app?.donator?.name_en
                  }}
                </td>
                <td>{{ parseFloat(app?.total_balance).toLocaleString() }}</td>
                <td>{{ app.created?.split("T")[0] }}</td>
                <td>
                  <button
                    v-if="!app.excution_time"
                    type="button"
                    style="margin-inline-end: 4px"
                    class="btn btn-success btn-sm"
                    @click="completeDonation(app)"
                  >
                    {{ $t("donations.complete_donation") }}
                  </button>
                  <button
                    v-if="app.excution_time && !app.gr_time"
                    type="button"
                    style="margin-inline-end: 4px"
                    class="btn btn-success btn-sm"
                    @click="receiveDonation(app)"
                  >
                    {{ $t("donations.receive_donation") }}
                  </button>
                  <button v-if="app.excution_time && app.gr_time" class="btn">
                    <i
                      v-if="app.excution_time"
                      style="color: green"
                      class="bx bx-check fa-2x"
                    ></i>
                  </button>
                  <button
                    @click="showShowDonation(app)"
                    v-if="app.excution_time"
                    class="btn"
                  >
                    <i
                      v-if="app.excution_time"
                      class="text-primary bx bx-show fa-2x"
                    ></i>
                  </button>

                  <button
                    v-if="!app.excution_time"
                    @click="preEditDonation(app)"
                    type="button"
                    class="btn mx-2 btn-primary btn-sm"
                  >
                    {{ $t("popups.edit") }}
                  </button>
                  <button
                    v-if="!app.excution_time"
                    type="button"
                    style="margin-inline-end: 4px"
                    class="btn btn-danger btn-sm"
                    @click="deleteDonation(app)"
                  >
                    {{ $t("popups.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--Start Add Modal-->

    <!--End Add Modal-->

    <!--Start Edit Modal-->

    <!--End Edit Modal-->

    <!--Start See Modal-->
    <div
      class="modal fade"
      id="donationDetailsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form>
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("purchases.order_details") }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-6"></div>
                <div
                  class="col-6"
                  style="display: flex; justify-content: flex-end"
                >
                  <!-- <button
                    type="button"
                    @click="
                      addPurchase.push({
                        addAsset: [{}],
                        addExpense: [{}],
                        addAccounts: [{}],
                        purchaseType: '',
                      })
                    "
                    class="btn float-end"
                  >
                    <span
                      class="bx bxs-plus-circle float-end fa-2x"
                      style="color: #2a3042 !important"
                    ></span>
                  </button> -->
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <h6 for="asset_id">{{ $t("fixed_assets.supplier") }}</h6>
                  <h5>
                    {{
                      $i18n.locale == "ar"
                        ? showedEditedDonation?.donator?.name
                        : showedEditedDonation?.donator?.name_en
                    }}
                  </h5>
                </div>
                <div class="col"></div>
              </div>
              <div class="purchase-container">
                <div class="row">
                  <div class="row d-flex align-items-center">
                    <div class="col">
                      <h6 for="asset_id">{{ $t("purchases.items.text") }}</h6>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>{{ $t("purchases.items.name") }}</th>
                          <th class=" ">
                            {{ $t("fixed_assets.serial_no") }}
                          </th>

                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.salvage_value") }}
                            </span>
                          </th>
                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.replacement_cost	") }}
                            </span>
                          </th>
                          <th class=" ">
                            {{ $t("fixed_assets.useful_life_years") }}
                          </th>
                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.under_warranty") }}
                            </span>
                          </th>
                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.warranty_exp") }}
                            </span>
                          </th>

                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.comment") }}
                            </span>
                          </th>
                          <th class=" ">
                            <span class="ant-table-column-title"
                              >{{ $t("fixed_assets.initial") }}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in showedEditedDonation.donation_details"
                          :key="item"
                        >
                          <td>
                            {{
                              $i18n.locale == "ar"
                                ? item?.fixed_asset?.name
                                : item?.fixed_asset?.name_en
                            }}
                          </td>
                          <td>
                            {{ item?.serial_no }}
                          </td>

                          <td>
                            {{ parseInt(item.salvage_value)?.toLocaleString() }}
                          </td>
                          <td>
                            {{
                              parseInt(item.replacement_cost).toLocaleString()
                            }}
                          </td>
                          <td>
                            {{
                              parseInt(item.useful_life_years).toLocaleString()
                            }}
                          </td>
                          <td class=" ">
                            {{
                              item?.under_warranty
                                ? $t("fixed_assets.yes")
                                : $t("fixed_assets.no")
                            }}
                          </td>
                          <td class=" ">
                            {{ item?.warranty_exp }}
                          </td>
                          <td class=" ">
                            {{ item?.comment }}
                          </td>
                          <td>
                            {{
                              parseFloat(
                                item.initial_book_value
                              )?.toLocaleString()
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <th>{{ $t("payments.items.total") }}</th>
                          <th class="total-style">
                            {{
                              parseFloat(
                                showedEditedDonation?.total_balance
                              ).toLocaleString()
                            }}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End See Modal-->

    <div
      class="modal fade"
      id="addOrEditDonationModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <form
            @submit.prevent="
              isItEdit
                ? editFixedAssetProductDonation()
                : registerFixedAssetProductDonation()
            "
          >
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{
                  isItEdit
                    ? $t("donations.code") + " #" + this.addOrEditDonation.id
                    : $t("donations.register_donation")
                }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("purchases.donator") }}</label>

                      <AutoComplete
                        v-model="addOrEditDonation.donator"
                        :suggestions="donators"
                        :complete-on-focus="true"
                        @complete="donatorSearch($event.query)"
                        @item-select="selectDonator(addOrEditDonation.donator)"
                        :optionLabel="showDonatorLabel"
                        class="w-100"
                        :input-class="'form-control w-100'"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("donations.reference_no") }}</label>

                      <input
                        required
                        type="text"
                        v-model="addOrEditDonation.reference_no"
                        class="form-control w-100"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <div>
                    <button
                      type="button"
                      @click="addOrEditDonation.donations.push({})"
                      class="btn"
                    >
                      <span
                        class="bx bxs-plus-circle fa-2x"
                        style="color: #2a3042 !important"
                      ></span>
                    </button>
                  </div>
                </div>
                <div
                  class="my-2 row"
                  v-for="(asset_product, index) in addOrEditDonation.donations"
                  :key="index"
                >
                  <div class="col-6"></div>
                  <div class="col-6 mt-3">
                    <button
                      type="button"
                      :disabled="addOrEditDonation.donations.length == 1"
                      @click="addOrEditDonation.donations.splice(index, 1)"
                      class="btn btn-danger float-end"
                    >
                      <span
                        class="bx bxs-trash"
                        style="color: #fff !important"
                      ></span>
                    </button>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ $t("fixed_assets.fixed_asset") }}</label>

                      <AutoComplete
                        v-model="asset_product.fixed_asset"
                        :suggestions="fixed_assets"
                        :complete-on-focus="true"
                        @complete="fixedAssetSearch($event.query)"
                        @item-select="
                          asset_product.fixed_asset_id =
                            asset_product.fixed_asset?.id
                        "
                        :optionLabel="showDonatorLabel"
                        class="w-100"
                        :input-class="'form-control w-100'"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.serial_no")
                    }}</label>
                    <input
                      required
                      type="text"
                      v-model="asset_product.serial_no"
                      class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.serial_no')"
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{ $t("emps.branch") }}</label>
                    <select
                      required
                      class="form-select"
                      v-model="asset_product.branch_id"
                      @change="getBranchSites(asset_product.branch_id, index)"
                    >
                      <option
                        v-for="branch in company_branches"
                        :key="branch"
                        :value="branch.id"
                      >
                        {{
                          $i18n.locale == "en" ? branch.name_en : branch.name
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="">
                      <label for="asset_id">{{
                        $t("fixed_assets.branch_site")
                      }}</label>
                      <select
                        required
                        class="form-select"
                        v-model="asset_product.branch_site_id"
                      >
                        <option
                          v-for="site in asset_product.branch_sites"
                          :key="site"
                          :value="site.id"
                        >
                          {{ $i18n.locale == "en" ? site.name_en : site.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.initial")
                    }}</label>
                    <currency-input
                      required
                      v-model="asset_product.initial_book_value"
                      class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.initial')"
                    />
                  </div>
                  <!-- <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.installation_date")
                    }}</label>
                    <input
                      required
                      v-model="asset_product.installation_date"
                      type="date"
                      class="form-control"
                    />
                  </div> -->
                  <template v-if="asset_product?.fixed_asset?.depreciable">
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.salvage_value")
                      }}</label>
                      <currency-input
                        required
                        :max="asset_product.initial_book_value"
                        v-model="asset_product.salvage_value"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.salvage_value')"
                      />
                    </div>

                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.useful_life_years")
                      }}</label>
                      <input
                        type="number"
                        required
                        v-model="asset_product.useful_life_years"
                        class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.useful_life_years')"
                      />
                    </div>
                  </template>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.replacement_cost")
                    }}</label>
                    <currency-input
                      required
                      :max="asset_product.initial_book_value"
                      v-model="asset_product.replacement_cost"
                      class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.replacement_cost')"
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="from-check form-check-inline">
                      <input
                        type="checkbox"
                        v-model="asset_product.under_warranty"
                        :id="'under_warranty-' + index"
                        class="form-check-input"
                      />
                      <label
                        class="form-check-label"
                        :for="'under_warranty-' + index"
                        >{{ $t("fixed_assets.under_warranty") }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-4"
                    v-if="asset_product.under_warranty"
                  >
                    <label for="asset_id">{{
                      $t("fixed_assets.warranty_exp")
                    }}</label>
                    <input
                      required
                      v-model="asset_product.warranty_exp"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.comment")
                    }}</label>
                    <textarea
                      v-model="asset_product.comment"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button
                type="submit"
                :disabled="
                  !(
                    addOrEditDonation?.donator && addOrEditDonation?.donator?.id
                  )
                "
                class="btn btn-primary"
              >
                {{ isItEdit ? $t("popups.edit") : $t("popups.add") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--   Purchases  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchModel ? search(page - 1) : get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchModel ? search(p) : get(p)"
          >{{ p }}</a
        >
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchModel ? search(page + 1) : get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
